import React from "react";
import "./Contact.css";

function Contact() {
  return (
<section id ="contact" class="contact-section py-4 bg-light">
  <div class="container">
    <div class="row align-items-center text-center text-md-start">
      
      <div class="col-md-6 mb-3 mb-md-0">
        <h2>Get in Touch</h2>
        <p>If you have any questions or want to discuss a project, reach out to us anytime.</p>
      </div>

      <div class="col-md-6 d-flex justify-content-center justify-content-md-end">
        <a href="tel:+16147066175" class="btn btn-contact btn-lg">
          <i class="fas fa-phone-alt me-2"></i> Call Us (614) 706-6175
        </a>
      </div>

    </div>
  </div>
</section>
  );
}

export default Contact;